import AScene from "../../library/ExtendedObjects/AScene.js";

export default class TransitionBushes
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene)
    {
        this.scene = scene;

        // return;
        
        this.topBush = this.scene.addImage(this.scene.mid.x + 50, 70, "transition2");
        this.topBush.scaleX = -1;
        this.topBush.setDepth(10);
        this.rightBush = this.scene.addImage(this.scene.size.width - 200, this.scene.mid.y + 150, "transition3");
        this.rightBush.scaleY = -1;
        this.rightBush.setDepth(10);
        this.botBush = this.scene.addImage(this.scene.mid.x, this.scene.mid.y + 280, "transition2");
        this.botBush.setDepth(10);
        this.leftbush = this.scene.addImage(200, this.scene.mid.y, "transition1");
        this.leftbush.setDepth(10);

        this.transitionOut();
    }

    transitionIn(sceneToLoad)
    {
        this.scene.addTween(this.rightBush, 1000, {x: this.scene.size.width - 200, easeParams: [.3]}, "Back");
        this.scene.addTween(this.leftbush, 1000, {x: 200, easeParams: [.3]}, "Back");
        this.scene.addTween(this.topBush, 1000, {y: 70, easeParams: [.3]}, "Back");
        this.scene.addTween(this.botBush, 1000, {y: this.scene.mid.y + 280, easeParams: [.3]}, "Back", ()=>{
            this.scene.sound.stopAll();
            this.scene.scene.start(sceneToLoad);
        });
    }

    transitionOut()
    {
        this.scene.addTween(this.rightBush, 1000, {x: this.scene.size.width + 430});
        this.scene.addTween(this.leftbush, 1000, {x: -380});
        this.scene.addTween(this.topBush, 1000, {y: -380});
        this.scene.addTween(this.botBush, 1000, {y: this.scene.mid.y + 800});
    }
}